var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import { toDate } from "../../utils/date";
import { TimeRangeType } from "../../utils/propTypes";
import { Overlay } from "./Overlay";
import { useTectonicContext } from "../TectonicProvider";
const defaultTimeOptions = [
    {
        type: "fixed",
        label: "Today",
        to: "now",
        from: "now-1h/d",
    },
    {
        type: "fixed",
        label: "Yesterday",
        to: "now-1h/d",
        from: "now-1d/d",
    },
    {
        type: "fixed",
        label: "This Month",
        to: "now",
        from: "now/M",
    },
    {
        type: "input",
        unit: "hours",
        default: 24,
    },
    {
        type: "input",
        unit: "days",
        default: 7,
    },
    {
        type: "select",
        unit: "months",
        label: "Month",
        default: new Date().getMonth(),
    },
];
function formatDate(date) {
    if (date === "now")
        return "Now";
    return toDate(date).toLocaleString();
}
function getTimeRangeForLabel(timeRange, timeOptions) {
    if (timeRange === null || timeRange === void 0 ? void 0 : timeRange.label) {
        return timeRange.label;
    }
    const found = timeOptions.find((timeOption) => timeOption.from === timeRange.from && timeOption.to === timeRange.to);
    if (found === null || found === void 0 ? void 0 : found.label) {
        return found.label;
    }
    if (timeRange.from && timeRange.to) {
        return `${formatDate(timeRange.from)} - ${formatDate(timeRange.to)}`;
    }
    return "Select Time Range";
}
export const TimeRangePicker = (_a) => {
    var { renderButton, classNames = [], timeOptions = defaultTimeOptions, align, onChange = () => { } } = _a, props = __rest(_a, ["renderButton", "classNames", "timeOptions", "align", "onChange"]);
    const ctx = useTectonicContext();
    const classes = ["tnic-timeRP", ...classNames].filter(Boolean);
    const [open, setOpen] = React.useState(false);
    const timeRange = props.timeRange || ctx.timeRange;
    const defaultTimeRange = props.defautTimeRange || ctx.defaultTimeRange;
    if (!timeRange || !timeRange.to) {
        return null;
    }
    return (React.createElement("div", { className: classes.join(" ") },
        renderButton(getTimeRangeForLabel(timeRange, timeOptions), () => setOpen(!open)),
        open && (React.createElement(Overlay, { align: align, stats: ctx.stats || {}, timeOptions: timeOptions, timeRange: timeRange, defaultTimeRange: defaultTimeRange, allowedTimeRange: props.allowedTimeRange, onClose: () => setOpen(false), onChange: (newTimeRange) => {
                if (ctx.setTimeRange)
                    ctx.setTimeRange(newTimeRange);
                onChange(newTimeRange);
            } }))));
};
TimeRangePicker.propTypes = {
    timeRange: TimeRangeType,
    renderButton: PropTypes.func,
    classNames: PropTypes.arrayOf(PropTypes.string),
    timeOptions: PropTypes.array,
    onChange: PropTypes.func,
};
//# sourceMappingURL=index.js.map